export default __webpack_public_path__ + "static/media/SciFood_Studio_2.7fa009d6.exe";